const PORTAL_ELEMENT_ID = 'portal-root';

let portal: HTMLElement | null;

export function getPortalElement(): HTMLElement {
  if (!portal) {
    // store the reference when used for the first time
    portal = document.getElementById(PORTAL_ELEMENT_ID);
  }

  if (!portal) {
    portal = document.createElement('div');
    portal.setAttribute('id', PORTAL_ELEMENT_ID);
    document.body.appendChild(portal);
  }

  return portal;
}
